<template>
  <div class="min-vh-100">
    <Topbar v-if="token"></Topbar>
    <div class="app container-fluid">
      <main>
        <vue-confirm-dialog />
        <router-view />
        <edit-password-modal />
      </main>
    </div>
  </div>
</template>

<script>
    import Topbar from './components/Topbar'
    import { mapGetters } from 'vuex'
    import EditPasswordModal from './components/EditPassworModal'

    export default {
        name: "app",
        components: {
            Topbar,
            EditPasswordModal
        },
        computed: {
            ...mapGetters({
                token: 'auth/token',
            }),
        },
        mounted () {
            if (!this.token) {
                this.$router.push({
                    name: 'login'
                })
            }
        }
    }
</script>
